module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/sea-shore_2ee59a.jpg";